import cn from 'classnames';

import UIResource from '@/components/UIResource';
import { useQFActiveLink } from '@/features/quickFindFilters/hooks';

import styles from './QuickFindWarning.module.scss';

type QuickFindWarningProps = {
  className?: string;
};

const QuickFindWarning = ({ className }: QuickFindWarningProps) => {
  const activeQFLink = useQFActiveLink();

  if (!activeQFLink) {
    return null;
  }

  const label = <b>{activeQFLink.linkTitle}</b>;

  return (
    <div className={cn(styles.root, className)}>
      <UIResource id="QuickFind.refineResults.message" values={{ label }} />
    </div>
  );
};

export default QuickFindWarning;
